import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
    setUserField: ["payload"]
});

const INITIAL_STATE = {
    id: "",
    idusuario: "",
    CNPJ: "",
    roles: [],
    userIP: "127.0.0.1"
};

const setUserField = (state, { payload }) => {
    const { field, value } = payload;

    return {
        ...state,
        [field]: value
    };
};

export { Types as UserTypes };

export { Creators as userActions };

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_USER_FIELD]: setUserField
});
